module.exports = function animateChart(component) {
    const chart = component.refs.chart ? component.refs.chart.getChart() : {};
    const chartReflow = chart.reflow;
    chart.reflow = () => {};
    setTimeout(() => (chart.reflow = chartReflow));
};



// WEBPACK FOOTER //
// ./src/helpers/animateChart.js